export default __webpack_public_path__ + "static/media/bg-lg-left-1.d7ade655.svg";